import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { withRouter, Link } from 'react-router-dom';

import { Button, Row, Select, Form, Field, RelationSelect, Attachments } from '@smartplatform/ui';
import { Editor } from '../../components';
import getPagesTree from './getPagesTree';
import Tree from './Tree';
import store from '../../store';
import AccessPopup from './AccessPopup';

import './style.scss';

const compareRoutes = (a, b) => {
	if (a.route < b.route) return -1;
	if (a.route > b.route) return 1;
	return 0;
};

@withRouter
@observer
export default class Edit extends React.Component {
	@observable record = null;
	@observable editors = [];
	@observable error = null;
	@observable route = null;
	@observable parentRoute = null;
	@observable routeError = null;
	@observable isSaving = false;
	@observable isSaved = false;
	@observable canEdit = true;
	@observable isAdmin = false;
	@observable accessPopup = false;

	pagesObj = {};
	editor = null;

	constructor(props) {
		super(props);
		this.isAdmin = store.model.roles ? store.model.roles.findIndex(role => role.name === 'admin') !== -1 : false;
		this.init();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// console.log('componentDidUpdate', this.id, this.props.match.params.id);
		if (this.id !== this.props.match.params.id) {
			this.load();
			if (this.editor) this.editor.setContent('');
		}
		this.id = this.props.match.params.id;
	}

	onEditorInit = editor => {
		console.log('onEditorInit', editor);
		this.editor = editor;
	};

	init = async () => {
		this.pagesObj = await getPagesTree();
		await this.load();
	};

	load = async () => {
		this.id = this.props.match.params.id;
		console.log('id', this.id);
		this.error = null;
		this.editors = [];

		if (this.id) {
			try {
				this.record = await store.model.Page.findById(this.id, {
					include: [
						/*
						{
							relation: 'children',
							scope: {
								fields: ['id', 'title', 'route', 'parentId', 'order'],
							}
						},
*/
						{ relation: 'parent' },
					],
				});
				if (this.record.showTitle === null) {
					this.record.showTitle = true;
				}
				if (this.record.hideFromGuests === null || this.record.hideFromGuests === undefined) {
					this.record.hideFromGuests = false;
				}
			} catch (e) {
				this.error = e.message;
			}
		} else {
			this.record = new store.model.Page({ hideFromGuests: false, showTitle: true });

			const parentId = store.route.params ? parseInt(store.route.params.parent) : null;
			if (parentId) {
				try {
					this.record.parent = await store.model.Page.findById(parentId);
				} catch (e) {
					console.error(e);
				}
			}
		}

		this.getParentRoute(this.record);
		this.route = this.record.route || '';
		if (this.parentRoute) {
			this.route = this.record.route ? this.record.route.replace(new RegExp(`^${this.parentRoute}`), '') : '';
		} else {
			this.route = this.route.replace(/\//g, '');
		}

		if (this.record.parent && this.record.parent.hide && !this.id) {
			this.record.hide = true;
		}

		console.log('>>>', this.parentRoute, this.record.route, this.route);
		if (!this.route) {
			this.route = '';
		}

		if (this.record.parent && this.record.parent.hide && !this.record.id) {
			this.record.hide = true;
		}

		await this.loadEditors();

		const index = this.editors.findIndex(editor => editor.userId === store.model.user.id);
		this.canEdit = this.isAdmin || index !== -1;
	};

	loadEditors = async () => {
		if (this.record.id) {
			this.editors = await store.model.PageEditor.find({
				where: { pageId: this.record.id },
				include: ['user'],
				order: 'id desc',
			});
		} else {
			this.editors = [];
		}
	};

	onEditorChange = (content, editor) => {
		this.record.text = content;
	};

	onTextChange = value => {
		console.log('onTextChange', value);
		this.record.text = value;
	};

	parent = page => {
		return page ? (
			<span className="parent-item">
				{page.route} <small>{page.title}</small>
			</span>
		) : (
			'Error'
		);
	};

	getParentRoute = record => {
		this.parentRoute = record.parent ? record.parent.route + '/' : null;
	};

	addChild = e => {
		store.route.path = '/admin/static/create';
		store.route.params = { parent: this.id };
		store.route.push();
	};

	onRouteChange = e => {
		let route = e.target.value;
		route = route.replace(/\//g, '').trim();
		this.route = route;
	};

	onParentChange = async parent => {
		console.log('onParentChange', parent);
		// this.parentRoute = this.getParentRoute(this.record);
		this.parentRoute = parent ? parent.route : null;
		this.getParentRoute(this.record);
	};

	insertLink = (e, page) => {
		e.preventDefault();
		console.log('insertLink', page);
	};

	scrollToTop = () => {
		const mainContent = document.getElementById('main-content');
		if (mainContent) mainContent.scrollTop = 0;
	};

	@action beforeSave = record => {
		console.log('beforeSave', record.route);
		if (!this.route || this.route.trim().length === 0) {
			this.routeError = 'Не задан путь к странице';
			return false;
		}
		this.record.route = (this.parentRoute || '/') + this.route;
		console.log('route', this.record.route);
		// if (this.record.hide === null) this.record.hide = false;
		this.isSaving = true;
		this.isSaved = false;
		// return false;
	};

	onSave = async record => {
		console.log('onSave', record.id, this.id);
		if (!record.order) {
			record.order = record.id;
			await record.save();
		}
		this.isSaving = false;
		this.isSaved = true;
		if (!this.id && !store.local.gotoListAfterSave) {
			this.props.history.push(`/admin/static/${record.id}`);
		} else {
			this.gotoParent();
		}
	};

	gotoParent = () => {
		this.props.history.push(this.record.parentId && this.isAdmin ? `/admin/static/${this.record.parentId}` : `/admin/static`);
	};

	toggleAfterSave = () => {
		store.local.gotoListAfterSave = !store.local.gotoListAfterSave;
		store.local.save();
	};

	onUploadStart = files => {};

	onUploadEnd = files => {
		console.log('onFilesUpload', files);
		if (this.attachmentsInstance) this.attachmentsInstance.reload();
	};

	toggleExpand = e => {
		store.local.expandPagesInside = !store.local.expandPagesInside;
		store.local.save();
	};

	showAccessPopup = () => (this.accessPopup = true);
	hideAccessPopup = () => (this.accessPopup = false);

	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;

		const parentFilter = this.id ? { where: { id: { neq: this.id } } } : {};

		const controls = (
			<span style={{ fontSize: 12 }}>
				<span style={{ marginLeft: 15 }}>
					{this.isSaving && <>Сохранение...&nbsp;</>}
					{this.isSaved && <>Сохранено.&nbsp;</>}
					{!this.isSaving && !store.local.gotoListAfterSave && this.isAdmin && <Link to="/admin/static">К списку страниц</Link>}
				</span>
			</span>
		);

		const editorsInfo = this.editors
			.reduce((result, editor) => {
				if (editor.user) {
					result.push(editor.user.username || editor.user.email);
				}
				return result;
			}, [])
			.join(', ');

		return (
			<div className="page-edit">
				<p>Страница</p>
				<Form
					key={this.record.id || 'new'}
					controls={controls}
					stay={true}
					noSave={!this.canEdit}
					noDelete={!this.canEdit}
					onSave={this.onSave}
					beforeSave={this.beforeSave}
					record={this.record}
					onDelete={this.gotoParent}
					rootPath="/admin"
					returnTo="/admin/static"
				>
					<div className="row">
						<Field property="title" label="Заголовок" disabled={!this.canEdit} className="col-lg-6" />
						<Field property="showTitle" label="Показывать заголовок" disabled={!this.canEdit} className="col-lg-3" />
						<Field property="hideFromGuests" label="Скрыть от неавторизованных" disabled={!this.canEdit} className="col-lg-3" />
					</div>

					{this.isAdmin && (
						<div className="row">
							<div className="form-field col-lg-4">
								<label>Путь к странице. {(this.parentRoute || '/') + this.route}</label>
								<div className="route-input">
									<div className="parents-routes" onClick={this.gotoParent}>
										{this.parentRoute || 'Главная/'}
									</div>
									<input value={this.route || ''} onChange={this.onRouteChange} />
								</div>
								<div className="field-error">{this.routeError}</div>
							</div>

							<Field
								relation="parent"
								className="parent-select col-lg-4"
								computed={this.parent}
								label={
									<span>
										Родительская страница
										{this.record.parent ? (
											<>
												{' '}
												(<Link to={`/admin/static/${this.record.parentId}`}>{this.parentRoute}</Link>)
											</>
										) : (
											''
										)}
									</span>
								}
							>
								<RelationSelect
									empty="Главная"
									onChange={this.onParentChange}
									filter={parentFilter}
									searchFields={['route', 'name']}
								/>
							</Field>
							<div className="col-lg-4" />
						</div>
					)}

					{this.isAdmin && (
						<div className="editors">
							<Button className="btn-primary" onClick={this.showAccessPopup} disabled={!this.record.id}>
								Доступ к редактированию
							</Button>
							<div className="list">{!this.record.id ? 'Сохраните страницу' : editorsInfo}</div>
						</div>
					)}

					{/*<Field property="order" />*/}

					{/*
				<Row>
					<Field property="breadcrumb" label="Текст хлебной крошки" />
					<Field property="breadcrumbUrl" label="Путь хлебной крошки" />
					<div />
				</Row>
*/}

					{this.isAdmin && (
						<div className="children-edit">
							<div className="row">
								<Field relation="nav" property="name" label="Тип навигации по дочерним страницам" className="col-lg-4">
									<RelationSelect filter={{ order: 'id asc' }} />
								</Field>
								{this.record.navId ? (
									<Field property="showText" label="Видимость текста этой страницы" className="col-lg-4">
										<Select
											items={[
												{ label: 'не показывать', value: null },
												{ label: 'показывать над навигацией', value: 'above' },
												{ label: 'показывать под навигацией', value: 'below' },
											]}
											empty="не показывать"
											noSearch
											isRequired
										/>
									</Field>
								) : (
									<div className="col-lg-4" />
								)}
								<div className="col-lg-4" />
							</div>

							{this.record.id && (
								<div style={{ marginBottom: 10 }}>
									<Button onClick={this.addChild}>Создать дочернюю страницу</Button>
								</div>
							)}

							{this.record.id && (
								<div className="children-list form-field">
									<label>
										Дочерние страницы{' '}
										<input type="checkbox" checked={store.local.expandPagesInside} onChange={this.toggleExpand} /> Раскрыть все
									</label>
									<Tree parentId={this.record.id} />
								</div>
							)}
						</div>
					)}

					<div className="form-field">
						<label>Текст страницы{!this.canEdit && <> (только чтение)</>}:</label>
						<Editor
							key={this.record.id || 'new'}
							value={this.record.text}
							onChange={this.onEditorChange}
							mediaModel={store.model.Image}
							onInit={this.onEditorInit}
							disabled={!this.canEdit}
							height={600}
							filesUploadData={{
								record: this.record,
								relation: 'attachments',
								property: 'filename',
								// accept: '.jpg, .svg',
								onStart: this.onUploadStart,
								onEnd: this.onUploadEnd,
							}}
						/>
					</div>

					{this.record.id && (
						<Attachments
							record={this.record}
							relation="attachments"
							store={store.model}
							canUpload={this.canEdit}
							instance={instance => (this.attachmentsInstance = instance)}
						/>
					)}

					{this.isAdmin && (
						<div>
							<small>
								<input
									type="checkbox"
									checked={store.local.gotoListAfterSave}
									disabled={!this.canEdit}
									onChange={this.toggleAfterSave}
								/>{' '}
								Переходить в родительскую страницу после сохранения
							</small>
						</div>
					)}
				</Form>

				{this.accessPopup && <AccessPopup page={this.record} onClose={this.hideAccessPopup} onChange={this.loadEditors} />}
			</div>
		);
	}
}
